import LoanArrears from './loan-arrears';

export default LoanArrears;
